/**
 * Firestore Helper Utilities
 * Sanitizes data before sending to Firestore
 */

/**
 * Recursively remove undefined values so Firestore never sees them.
 */
export function sanitizeForFirestore(obj) {
  if (obj == null || typeof obj !== 'object') return obj;

  if (Array.isArray(obj)) {
    return obj
      .map(sanitizeForFirestore)
      .filter((v) => v !== undefined);
  }

  const clean = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined) continue;
    clean[key] = sanitizeForFirestore(value);
  }
  return clean;
}
